export default __webpack_public_path__ + "static/media/prelaunch-icon.c48ba270.svg";